import React, { useContext } from "react";

const SkillMappedWithPromptPopup = (props) => {
  const { handleCloseMappingPopup } = props;

  const closePopup = () => {
    handleCloseMappingPopup();
  };

  return (
    <div className="modal-wrapper show-modal-wrapper delete-prompt-modal">
      <div className="modal-block border-radius-5">
        <div className="confirmation-content-wrapper">
          <div className="modal-content ">
            <div className="modal-popup-header">
              <h3 className="popup-heading">Cannot Delete This Skill</h3>
            </div>
            <div className="modal-body">
              <p>This skill is mapped to prompt(s). Please remove the associations before deleting.</p>
            </div>
            <div className="popup-btn-container-skill">
              <button
                type="button"
                onClick={() => closePopup()}
                className="genrate-btn"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillMappedWithPromptPopup;
